<template>
	<div class="circles-mine-content">
		<ul class="circles-type-list">
			<li v-for="(item, index) in typeList" @click="changeType(index)" :class="{active: typeIndex === index}" :key="index">{{item.label}}</li>
		</ul>
		<ss-circles-list :value="curData_" :finish="finish_" :busy="busy_" mode="3" />
		<div class="right-navigation-box">
			<ssNavigation v-if="pageTotal_ > pageSize" :total="pageTotal_" v-model="curPage" :size="pageSize" />
		</div>
	</div>
</template>

<script>
	import ssCirclesList from '@/components/ss-circles-list/ss-circles-list.vue'
	import listMixin from '@/mixins/list.js'
	export default {
		mixins: [ listMixin ],
		name: 'culturalCriclesMine',
		components:{
			ssCirclesList
		},
		data() {
			return {
				typeList: [{
					value: '',
					label: '全部'
				}]
			}
		},
		created() {
			this.getCulturalClassify();
		},
		methods: {
			async getCulturalClassify() {
				let res = await this.$http('culturalClassify');
				if(res.code === 1){
					res.data.forEach(o => {
						o.label = o.name;
						o.value = o.id;
					})
					this.typeList = this.typeList.concat(res.data);
				}
			}
		}
	}
</script>

<style lang="scss">
	@import './css/mine.scss';
</style>
